import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.5 7.121a.75.75 0 1 1-1.5 0V2.932l-6.218 6.22A.75.75 0 0 1 9.72 8.09l6.219-6.219H11.75a.75.75 0 1 1 0-1.5h6a.75.75 0 0 1 .75.75v6Zm-3.75 2.25a.75.75 0 0 0-.75.75v6.75H2v-12h6.75a.75.75 0 1 0 0-1.5H2a1.5 1.5 0 0 0-1.5 1.5v12a1.5 1.5 0 0 0 1.5 1.5h12a1.5 1.5 0 0 0 1.5-1.5v-6.75a.75.75 0 0 0-.75-.75Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "external-link"}) } }